import r from '../Utils/fetch'

const w: any = window
const endPoint = `${w.API_BILLING_URL}`

export interface IStripeInvoice {
	id: string
	number?: string
	status: 'draft' | 'open' | 'paid' | 'void' | 'uncollectible'
	amount_due: number
	amount_paid: number
	amount_remaining: number
	currency: string
	created: number
	due_date?: number
	hosted_invoice_url?: string
	invoice_pdf?: string
	paid: boolean
}

export const ensureStripeCustomer = (
	billingAccountId: string,
	stripeCustomerId?: string
): Promise<{ stripeCustomerId: string }> =>
	r({
		url: `${endPoint}/v1/admin/billing-accounts/${billingAccountId}/stripe-customer`,
		method: 'POST',
		data: stripeCustomerId ? { stripeCustomerId } : {},
	})

export interface ICreateEnterpriseSubscriptionPayload {
	amount: number // centimes
	currency?: string
	daysUntilDue?: number
	startDate?: string
}

export const createEnterpriseSubscription = (
	billingAccountId: string,
	payload: ICreateEnterpriseSubscriptionPayload
): Promise<any> =>
	r({
		url: `${endPoint}/v1/admin/billing-accounts/${billingAccountId}/enterprise-subscription`,
		method: 'POST',
		data: payload,
	})

export interface IEntitlement {
	id: number
	billingAccountId: string
	featureId: number
	feature?: { id: number; slug: string; name: string; type: string }
	value: string
	source: string
}

export const listEntitlements = (billingAccountId: string): Promise<IEntitlement[]> =>
	r({
		url: `${endPoint}/v1/admin/billing-accounts/${billingAccountId}/entitlements`,
		method: 'GET',
	})

export const resyncStripe = (billingAccountId: string): Promise<{ ok: boolean }> =>
	r({
		url: `${endPoint}/v1/admin/billing-accounts/${billingAccountId}/stripe/resync`,
		method: 'POST',
	})

export const listStripeInvoices = (billingAccountId: string): Promise<IStripeInvoice[]> =>
	r({
		url: `${endPoint}/v1/admin/billing-accounts/${billingAccountId}/invoices`,
		method: 'GET',
	})

export const markInvoicePaidManually = (invoiceId: string): Promise<IStripeInvoice> =>
	r({
		url: `${endPoint}/v1/admin/invoices/${invoiceId}/mark-paid-manually`,
		method: 'POST',
	})
